import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import { startWithBasePath, removeBasePath } from 'utils/methods'

import * as Styled from './styles'

const LinkWrapper = ({ href, children }) => {
  const { basePath } = useRouter()

  if (startWithBasePath(href, basePath)) {
    const postSalesHref = removeBasePath(href, basePath)
    return (
      <Styled.Wrapper hasCursor={!!href}>
        <Link href={postSalesHref}>{children}</Link>
      </Styled.Wrapper>
    )
  }
  return (
    <Styled.Wrapper hasCursor={!!href}>
      <a href={href}>{children}</a>
    </Styled.Wrapper>
  )
}

export default LinkWrapper
